// @flow

const config: {
  [string]: string
} = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || '',
  MAPLE_API: process.env.REACT_APP_MAPLE_API || '',
  AUTH_ENDPOINT: process.env.REACT_APP_AUTH_ENDPOINT || '',
  AUTH0_REDIRECT: process.env.REACT_APP_AUTH0_REDIRECT || '',
  AUTH0_CLIENT: process.env.REACT_APP_AUTH0_CLIENT || '',
  HELLOSIGN_CLIENT: process.env.REACT_APP_HELLOSIGN_CLIENT || '',
  STRIPE_CLIENT: process.env.REACT_APP_STRIPE_CLIENT || '',
  SKIP_HELLOSIGN_VERIFICATION: process.env.REACT_APP_SKIP_HELLOSIGN_VERIFICATION || '',
  ORIGIN: process.env.REACT_APP_ORIGIN || '',
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  GOOGLE_ANALYTICS_TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID || '',
  SDM_INSTITUTION_ID: process.env.REACT_APP_SDM_INSTITUTION_ID || '',
  RESET_PW_REDIRECT: process.env.REACT_APP_RESET_PW_REDIRECT || ''
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js